import { CmsComponentsBase } from '@/cmsComponents/base';

const LandingPageCmsComponents = CmsComponentsBase;

export default LandingPageCmsComponents;
